import { Variant } from "../enum-types";
import { IconSet, IconSizes } from "../icon/icon.props";

export interface AtlStatusIndicatorProps {
    reverseOrder?: boolean;
    variant?: Variant;    
    icon?: string;
    size?: IconSizes;
    iconSet?: IconSet;
    loading?: boolean;
}

export enum AtlStatusIndicatorTagNames {
    StatusIndicator = 'atlantis-status-indicator'
}